export default "__VITE_ASSET__DsGRpHq9__"